var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('information-default',{attrs:{"nameButton":_vm.$t('views.ForgotPassSuccess.nameButton'),"action":"login","title":_vm.$t('views.ForgotPassSuccess.title')}})}
var staticRenderFns = []

export { render, staticRenderFns }